import * as config from '../../json/config.json';
import {Injectable} from '@angular/core';
import {Store} from '../types/store';

@Injectable({
	providedIn: 'root',
})
export class ConfigService extends Store<any> {
	constructor() {
		super((config as any).default);
	}

	// don't use - call state$ from base class
	public get config(): any {
		return Object.assign({}, (config as any).default);
	}
}
